import * as serviceWorker from 'serviceWorker'; // Corrected import path
import ReactDOM from 'react-dom/client'; // Import ReactDOM for createRoot
import { Provider } from 'react-redux'; // Import Provider from react-redux
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import { store } from './store'; // Adjusted path assuming store is in src/store
import App from './App'; // Adjusted path assuming App is in src/App

// Style + assets
import './assets/scss/style.scss';

// ==============================|| REACT DOM RENDER ||============================== //

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();